import apiBase from './apiBase';

class AuthenticationApi {
  static signIn(signInData) {
    return apiBase.post('/budget/participant-accounts/authenticate', signInData);
  }

  static signOut() {
    return apiBase.post('/budget/participant-accounts/sign-out');
  }

  static register(data) {
    return apiBase.post('/budget/participant-accounts/register', data);
  }

  static recoverPassword(recoverPasswordData) {
    return apiBase.post('/budget/participant-accounts/recover-password', recoverPasswordData);
  }

  static activateAccount(activationData) {
    return apiBase.post('/budget/participant-accounts/activate-account', activationData);
  }

  static resetPassword(resetPasswordData) {
    return apiBase.post('/budget/participant-accounts/set-password', resetPasswordData);
  }

  static me() {
    return apiBase.get('/budget/participant-accounts/me');
  }

  static updateProfile(data) {
    return apiBase.put('/budget/participant-accounts/me', data);
  }

  static updateSettings(data) {
    return apiBase.put('/budget/participant-accounts/me/settings', data);
  }

  static deleteAccountByParticipant() {
    return apiBase.delete('/budget/participant-accounts/me');
  }
}

export default AuthenticationApi;



// WEBPACK FOOTER //
// ./src/api/budgetAuthenticationApi.js